module.exports = __webpack_public_path__ + "static/media/familia.e3a96a1b.png";